// import React from "react"
// import ReactDOM from 'react-dom/client';
// import App from "./App"
// import * as serviceWorker from "./serviceWorker"
// import { BrowserRouter } from "react-router-dom"
// import "./i18n"
// import { Provider } from "react-redux"

// import store from "./store"

// const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   <Provider store={store}>
//       <>
//       <BrowserRouter basename={process.env.PUBLIC_URL}>
//         <App />
//       </BrowserRouter>
//   </>
//     </Provider>
// );

// serviceWorker.unregister()


import React from "react";
import ReactDOM from 'react-dom/client';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";

import store from "./store";
import { AuthProvider } from "./context/AuthContext"; 
import Swal from 'sweetalert2';

const root = ReactDOM.createRoot(document.getElementById('root'));
window.Swal = Swal;

root.render(
  <Provider store={store}>
    <AuthProvider> 
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </Provider>
);

serviceWorker.unregister();
